import { app } from '../../../bootstrap/core';
import { radioAccordionComponent } from './radioAccordion.component';
import './section/radioAccordionSection';

app.component('radioAccordion', radioAccordionComponent);
